export interface LinkItem {
  label: string;
  href: string;
}

export interface Section {
  title: string;
  links: LinkItem[];
}

export const footerLinks: Section[] = [
  {
    title: "JetSMART",
    links: [
      { label: "Who We Are", href: "" },
      { label: "Our Model", href: "" },
      { label: "Destinations", href: "" },
      { label: "American Airlines Alliance", href: "" },
      { label: "Optional Services", href: "" },
      { label: "JetSMART Packs", href: "" },
      { label: "Companies", href: "" },
      { label: "Charters", href: "" },
      { label: "Public Market", href: "" },
      { label: "Banco Estado Clients", href: "" },
      { label: "JetSMART Cargo", href: "" },
      { label: "Request your SMART card", href: "" },
      { label: "Hotels", href: "" },
      { label: "Cars", href: "" },
    ],
  },
  {
    title: "Need Help?",
    links: [
      { label: "Help Center", href: "" },
      { label: "Frequently Asked Questions", href: "" },
      { label: "Flexibility Policy", href: "" },
      { label: "Change and/or Refund Request", href: "" },
      { label: "Assignment or Withdrawal Request", href: "" },
      { label: "Refund of Boarding Fees", href: "" },
      { label: "Connecting Flights", href: "" },
      { label: "Group Bookings", href: "" },
      { label: "Do your check-in HERE", href: "" },
      { label: "Manage your flight HERE", href: "" },
      { label: "Contact Us", href: "" },
      { label: "Agency Help Center", href: "" },
    ],
  },
  {
    title: "Transparency",
    links: [
      { label: "Conditions of Carriage", href: "" },
      { label: "Specific Regulations", href: "" },
      { label: "Passenger Rights", href: "" },
      { label: "Privacy Policy", href: "" },
      { label: "Discount Club Terms and Conditions", href: "" },
      { label: "Terms and Conditions for Pets on Board", href: "" },
      { label: "Terms and Portal Conditions of Companies", href: "" },
      { label: "JetSmart terms and conditions - BancoEstado", href: "" },
      { label: "BancoEstado", href: "" },
      { label: "Legal Bases", href: "" },
      { label: "Gift Card Terms and Conditions", href: "" },
      { label: "PVC JetSMART", href: "" },
      { label: "JAC Passenger Rights", href: "" },
    ],
  },
  {
    title: "Work with us",
    links: [{ label: "Apply", href: "" }],
  },
];

export const INITIAL_COUNT = 6;
